<div class="jumbotron">
  <div class="container">
    <div class="row g-3 align-items-center">
      <div class="col-auto">
        <label for="monthYear" class="col-form-label">Month</label>
      </div>
      <div class="col-auto">
        <input type="month" id="monthYear" class="form-control" [(ngModel)]="monthYear">
      </div>
      <div class="col-auto">
        <span class="form-text">Please select month/year from the box.</span>
      </div>
      <div class="col-auto">
        <button type="button" class="btn btn-success" (click)="loadReport()">Get Report</button>
      </div>
    </div>

    <div class="row g-3 mt-3">
      <div class="col-md-4">
        <div class="card summary-card">
          <div class="card-header">Total Amount</div>
          <div class="card-body">
            <h4 class="mb-0">{{ totalAmount | number:'1.3-3' }} OMR</h4>
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="card summary-card">
          <div class="card-header">Invoices</div>
          <div class="card-body">
            <h4 class="mb-0">{{ invoiceCount | number }}</h4>
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="card summary-card">
          <div class="card-header">Average Invoice</div>
          <div class="card-body">
            <h4 class="mb-0">{{ averageAmount | number:'1.3-3' }} OMR</h4>
          </div>
        </div>
      </div>
    </div>

    <div class="card mt-4">
      <div class="card-header">Daily Payments</div>
      <div class="card-body">
        @if (invoiceCount === 0) {
          <p class="text-muted mb-0">No data found</p>
        } @else {
          <div class="daily-chart">
            @for (bar of dailyBars; track bar.label) {
              <div class="daily-col" [title]="bar.label + ': ' + (bar.amount | number:'1.3-3') + ' OMR (' + bar.count + ')'">
                <div class="daily-value">{{ bar.amount ? (bar.amount | number:'1.0-0') : '' }}</div>
                <div class="daily-track">
                  <div class="daily-bar" [style.height.%]="bar.height"></div>
                </div>
                <div class="daily-label">{{ bar.label }}</div>
              </div>
            }
          </div>
        }
      </div>
    </div>

    <div class="card mt-4 mb-4">
      <div class="card-header">Payments by Type</div>
      <div class="card-body">
        @if (typeBars.length === 0) {
          <p class="text-muted mb-0">No data found</p>
        } @else {
          @for (bar of typeBars; track bar.label) {
            <div class="type-row">
              <div class="type-meta">
                <strong>{{ bar.label }}</strong>
                <span>{{ bar.amount | number:'1.3-3' }} OMR · {{ bar.count }} invoices</span>
              </div>
              <div class="type-track">
                <div class="type-bar" [style.width.%]="bar.height"></div>
              </div>
            </div>
          }
        }
      </div>
    </div>
  </div>
</div>
